import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCookieBite } from "@fortawesome/free-solid-svg-icons";
import "./cookie.css";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) setShowBanner(true);
  }, []);

  const handleAccept = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 });
    setShowBanner(false);
  };

  const handleReject = () => {
    Cookies.set("cookieConsent", "rejected", { expires: 365 });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-panel">
      <div className="cookie-title">
        <FontAwesomeIcon icon={faCookieBite} className="cookie-icon" />
        <span>Cookie-uri</span>
      </div>

      <p className="cookie-text">
        Folosim cookie-uri necesare pentru functionarea site-ului. Cu acordul
        tau, folosim si cookie-uri de analiza pentru a imbunatati experienta pe
        ContaLearn.
      </p>

      <Link to="/politicacookies" className="cookie-link">
        Afla mai multe despre politica de cookie-uri.
      </Link>

      <div className="cookie-actions">
        <button className="accept-btn" onClick={handleAccept}>
          Accept
        </button>

        <button className="reject-btn" onClick={handleReject}>
          Respinge
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;